(() => {
  const CLARITY_RETRY_MS = 250;
  const CLARITY_RETRY_MAX = 8;

  /**
   * @param {Array<{name?: string, value?: string}> | undefined} options
   * @returns {Record<string, string>}
   */
  function optionMap(options) {
    /** @type {Record<string, string>} */
    const map = {};
    if (!Array.isArray(options)) return map;

    for (const option of options) {
      const name = String(option?.name || '')
        .trim()
        .toLowerCase();
      const value = String(option?.value || '').trim();
      if (!name || !value) continue;

      if (name.includes('size')) map.size = value;
      if (name.includes('fram')) map.frame = value;
      if (name.includes('mat')) map.mat = value;
    }

    return map;
  }

  /**
   * @param {unknown} price
   * @returns {number | undefined}
   */
  function centsToDollars(price) {
    const amount = Number(price);
    if (!Number.isFinite(amount)) return undefined;
    return amount / 100;
  }

  /**
   * @param {Event} event
   * @returns {Record<string, string | number>}
   */
  function buildProps(event) {
    const detail = /** @type {{ detail?: { data?: Record<string, any>, sourceId?: string } }} */ (event).detail || {};
    const data = detail.data || {};
    const item = data.item || {};
    const options = optionMap(item.options_with_values);
    const target = event.target instanceof Element ? event.target : null;

    /** @type {Record<string, string | number>} */
    const props = {
      product_id: String(item.product_id || data.productId || ''),
      product_name: String(item.product_title || ''),
      variant_id: String(item.variant_id || detail.sourceId || ''),
      variant_title: String(item.variant_title || ''),
      sku: String(item.sku || ''),
      size: options.size || '',
      frame: options.frame || '',
      mat: options.mat || '',
      quantity: Number(data.itemCount || item.quantity || 1) || 1,
      add_source: target?.closest('quick-add-dialog') ? 'quick_add' : 'pdp',
      product_url: window.location.href,
    };

    const price = centsToDollars(item.price);
    if (price !== undefined) props.price = price;

    const currency = window.Shopify?.currency?.active;
    if (currency) props.currency = currency;

    return props;
  }

  /**
   * @param {Record<string, string | number>} props
   */
  function capturePosthog(props) {
    if (typeof window.posthog?.capture === 'function') {
      window.posthog.capture('add_to_cart', props);
    }
  }

  /**
   * @param {Record<string, string | number>} props
   * @param {number} [attempt]
   */
  function captureClarity(props, attempt = 0) {
    if (typeof window.clarity === 'function') {
      window.clarity('event', 'add_to_cart');

      /** @type {Record<string, string | number | undefined>} */
      const tags = {
        added_product: props.product_name,
        added_variant: props.variant_title,
        added_size: props.size,
        added_frame: props.frame,
        added_mat: props.mat,
        add_source: props.add_source,
      };

      for (const [key, value] of Object.entries(tags)) {
        if (value) window.clarity('set', key, String(value));
      }
      return;
    }

    if (attempt >= CLARITY_RETRY_MAX) return;

    setTimeout(() => {
      try {
        captureClarity(props, attempt + 1);
      } catch {
        // Never block add-to-cart on analytics.
      }
    }, CLARITY_RETRY_MS);
  }

  /**
   * @param {Event} event
   */
  function onCartUpdate(event) {
    try {
      const data = /** @type {{ detail?: { data?: { source?: string, didError?: boolean } } }} */ (event).detail?.data;
      if (!data || data.source !== 'product-form-component' || data.didError) return;

      const props = buildProps(event);
      capturePosthog(props);
      captureClarity(props);
    } catch {
      // Never block add-to-cart on analytics.
    }
  }

  document.addEventListener('cart:update', onCartUpdate);
})();
